import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-closing-sections',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './closing-sections.component.html',
  styleUrls: ['./closing-sections.component.scss']
})
export class ClosingSectionsComponent {
    @Input() jumpToSection!:(sectionId:string) => void;

}
